module.exports = __webpack_public_path__ + "static/media/book_payam_ae_hijaz_persian_7.5dad14dd.jpg";